import { render, staticRenderFns } from "./filter-empty-placeholder.vue?vue&type=template&id=4055951d&scoped=true&"
import script from "./filter-empty-placeholder.vue?vue&type=script&lang=ts&"
export * from "./filter-empty-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./filter-empty-placeholder.vue?vue&type=style&index=0&id=4055951d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055951d",
  null
  
)

export default component.exports